import { render, staticRenderFns } from "./ServerDetailDialog.vue?vue&type=template&id=2f887742&scoped=true&"
import script from "./ServerDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ServerDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f887742",
  null
  
)

export default component.exports